import { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { recoveryApi } from '../services/recoveryApi';
import type { Cpc25Report, Cpc25ReportSummary } from '../types/LegalCase';

const EMPTY_SUMMARY: Cpc25ReportSummary = {
    count: 0,
    estimatedLoss: 0,
    estimatedLossFormatted: null,
    provision: 0,
    provisionFormatted: null,
    offSuggestion: 0,
    overridden: 0,
};

const EMPTY_REPORT: Cpc25Report = {
    entities: [],
    summary: EMPTY_SUMMARY,
    attention: [],
};

// Gerencia o relatório consolidado CPC 25 (equivalente calculado da aba VALORES): busca o
// consolidado por entidade credora × polo × classificação, com filtro opcional por entidade.
// Sem escrita — é read-only.
export default function useCpc25Report() {
    const [report, setReport] = useState<Cpc25Report>(EMPTY_REPORT);
    const [isLoading, setIsLoading] = useState(false);
    const [creditorEntity, setCreditorEntity] = useState('');

    const fetchReport = useCallback(async () => {
        setIsLoading(true);
        try {
            const result = await recoveryApi.getCpc25Report({
                creditorEntity: creditorEntity || undefined,
            });
            setReport(result || EMPTY_REPORT);
        } catch (e: any) {
            toast.error(e?.message || 'Erro ao carregar o relatório CPC 25');
        } finally {
            setIsLoading(false);
        }
    }, [creditorEntity]);

    useEffect(() => { fetchReport(); }, [fetchReport]);

    return {
        report,
        isLoading,
        creditorEntity,
        setCreditorEntity,
        refresh: fetchReport,
    };
}
